export interface DiscountAuditGroup {
  kilos: number;
  discount: number;
  allowed: number | null;
  evidence: "final" | "historical" | "none";
  requestedAt: string | null;
  requestedBy: string;
  quoteFolio: number | null;
}
export interface DiscountAuditInvoice {
  type: string;
  folio: number;
  date: string;
  customer: string;
  user: string;
  totalKilos: number;
  quoteFolio: number | null;
  hasAuthorization: boolean;
  groups: DiscountAuditGroup[];
}
export interface DiscountAuditReport {
  branchName: string;
  from: string;
  to: string;
  generatedAtUtc: string;
  policyConfigured: boolean;
  evaluatedInvoices: number;
  unverifiableInvoices: number;
  invoices: DiscountAuditInvoice[];
}
export function filterAudit(rows: DiscountAuditInvoice[], status: string, search: string): DiscountAuditInvoice[] {
  const query = search.trim().toLocaleLowerCase("es-MX");
  return rows.filter(row => (status === "all" || row.hasAuthorization === (status === "with")) &&
    (!query || [row.type + "-" + row.folio, row.customer, row.user, row.quoteFolio ? "PR-" + row.quoteFolio : "",
      ...row.groups.map(g => g.quoteFolio ? "PR-" + g.quoteFolio : "")].join(" ").toLocaleLowerCase("es-MX").includes(query)));
}
export function csvCell(value: string | number): string {
  let text = String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}
